module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "t1"
  }, [_vm._v("Elogios para Andrew Grey y su libros")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t1"
  }, [_vm._v("\"")]), _c('span', {
    staticClass: "t1"
  }, [_c('i', [_vm._v("La mejor venganza.")])]), _c('span', {
    staticClass: "t1"
  }, [_vm._v("\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_vm._v("… una intrigante historia sobre dos hombres que en vez de rendirse, nos enseñan que vivir bien es, en definitiva, la mejor venganza de todas. Esta fenomenal historia me ha encantado desde el principio.")]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "t2"
  }, [_c('i', [_c('img', {
    attrs: {
      "alt": "img1.png",
      "src": "images/img1.png"
    }
  })])]), _c('i', [_vm._v(" 5Angels y Recomendaciones para leer de Fallen Angel Reviews.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_vm._v("… una historia deliciosa de dos personas que encuentran el amor a pesar de los problemas del pasado, presente y de un futuro incierto que les acechan. El autor embruja a los lectores cautivándoles de principio a fin. Con personajes intrigantes, un argumento ágil y algunas escenas de sexo de gran ternura, Grey nos ofrece una historia poderosa que dejará a los lectores sin aliento.")]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "t2"
  }, [_c('i', [_c('img', {
    attrs: {
      "alt": "img1.png",
      "src": "images/img1.png"
    }
  })])]), _c('i', [_vm._v(" 5 Hearts from Love Romances and More.")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t1"
  }, [_c('i', [_vm._v("“Embotellado”")])])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_vm._v("Llegué a preocuparme en serio por los personajes, y al final aplaudía.")]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "t2"
  }, [_c('i', [_c('img', {
    attrs: {
      "alt": "img1.png",
      "src": "images/img1.png"
    }
  })])]), _c('i', [_vm._v("4 ½ Starts from Rainbow Reviews.")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t1"
  }, [_c('i', [_vm._v("“El Chico del Jueves”")])])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_vm._v("… la experiencia de descubrir este bello mundo es tan refrescante… una lectura perfecta después de un día caótico o estresante. ¡Altamente recomendable!")]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_vm._v("Hay algunos giros en el argumento que definitivamente no veía venir, y que me mantuvieron pegado a la silla. Hacen que la historia sea completamente impredecible. Su habilidad para mezclar folclore con realidad, añadiendo romance y suspense hace que los libros de Grey estén en los puestos más altos de las listas de lectura obligada.")]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "t2"
  }, [_c('i', [_c('img', {
    attrs: {
      "alt": "img1.png",
      "src": "images/img1.png"
    }
  })])]), _c('i', [_vm._v("5 Angels de Fallen Angel Reviews.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ac69130","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/002.vue
// module id = 57
// module chunks = 0